import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsDownEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.58333 4H5.75C4.64543 4 3.75 4.89543 3.75 6V10C3.75 11.1046 4.64543 12 5.75 12H8.2524C8.43135 12 8.59666 12.0956 8.68586 12.2508L11.2195 16.6571C11.335 16.858 11.5766 16.9549 11.7944 16.8754C14.5951 15.8532 13.4713 13.8482 12.8967 12.1299C12.8752 12.0656 12.9234 12 12.9911 12H14.3227C15.7074 12 16.6732 10.6267 16.2048 9.3236L15.0052 5.9854C14.5771 4.79432 13.4476 4 12.1819 4H7.58333ZM7.58333 4V12",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgThumbsDownEmpty;
